module.exports = __webpack_public_path__ + "img/web_2_2x.e9d39013.webp";